import { Component, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmation-cancel',
  imports: [CommonModule],
  templateUrl: './confirmation-cancel.html',
    styleUrl: './confirmation-cancel.scss',
})
export class ConfirmationCancel {
  private router = inject(Router);
  dismissed = output<void>();
  productId = input();
  productType = input.required<'sub-product' | 'has-sub' | 'has-no-sub' | null | undefined>();
  subProductId = input();

  onConfirm() {
    if (this.productType() === 'sub-product')
      this.router.navigate(['/admin/products/view-sub-product', this.productId(), this.subProductId()]);
    else this.router.navigate(['/admin/products/view-product', this.productId()]);
  }

  onDismiss() {
    this.dismissed.emit();
  }
}
